import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GenerateGenericSurveyLinkRPC } from "./generateGenericSurveyLinkRPC";

export class GenerateGenericSurveyLinkRPCClientImpl extends GenerateGenericSurveyLinkRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GenerateGenericSurveyLinkRPC.Request): Promise<LeoRPCResult<GenerateGenericSurveyLinkRPC.Response, GenerateGenericSurveyLinkRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/GenerateGenericSurveyLink",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GenerateGenericSurveyLinkRPC.ResponseDTO,
      GenerateGenericSurveyLinkRPC.Errors.ErrorsDTO,
      GenerateGenericSurveyLinkRPC.Response,
      GenerateGenericSurveyLinkRPC.Errors.Errors
    >(
      response,
      "survey/GenerateGenericSurveyLink",
      GenerateGenericSurveyLinkRPC.Response.fromDTO,
      GenerateGenericSurveyLinkRPC.Errors.fromDTO
    );
  }
}
